import { stringifyTrackingInfo } from 'components/LightConversation/components/LogisticsInfo/utils';
import { useCallback, useEffect, useState } from 'react';
import { overseaTranslate } from 'services/api/overseaTranslate';
import { useSystemLanguageValue } from '../system/useSystem';
import { useMutation } from '@tanstack/react-query';

interface TrackingInfoItem {
  description: string;
  descriptionTranslation: string;
  updateTime: string;
  attachment: Conversation.Trade.TrackingInfoAttachment[];
}

export const useTrackingInfo = (trackingInfo: Conversation.Trade.BaseTrackingInfo[]) => {
  const [viewType, setViewType] = useState<'original' | 'translate'>('original');
  const systemLang = useSystemLanguageValue();
  const [trackingInfoItems, setTrackingInfoItems] = useState<TrackingInfoItem[]>([]);

  const initTrackingInfoItems = useCallback(() => {
    setTrackingInfoItems(
      trackingInfo.map((item) => {
        return {
          description: item.description,
          updateTime: item.updateTime,
          descriptionTranslation: '',
          attachment: item.attachment,
        };
      }),
    );
    setViewType('original');
  }, [trackingInfo]);

  const { isLoading, mutateAsync: triggerTranslate } = useMutation({
    mutationFn: async () => {
      const data = stringifyTrackingInfo(trackingInfo);
      const res = await overseaTranslate(data, systemLang as General.Language, 'side');
      return res;
    },
    onSuccess: (data) => {
      setViewType('translate');
      setTrackingInfoItems(
        trackingInfo.map((item, index) => {
          return {
            description: item.description,
            updateTime: item.updateTime,
            descriptionTranslation: data[index],
            attachment: item.attachment,
          };
        }),
      );
    },
    onError: () => {
      setViewType('original');
      setTrackingInfoItems(
        trackingInfo.map((item) => {
          return {
            description: item.description,
            updateTime: item.updateTime,
            descriptionTranslation: '',
            attachment: item.attachment,
          };
        }),
      );
    },
  });

  useEffect(() => {
    initTrackingInfoItems();
    triggerTranslate();
  }, [initTrackingInfoItems, triggerTranslate]);

  return {
    viewType,
    trackingInfoItems,
    isLoading,
    triggerTranslate,
    onChangeViewType: setViewType,
  };
};
